"use strict";

var _classCallCheck = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var paho_mqtt_1 = require("../../clients/paho-mqtt");

var pb_1 = require("./pb");

var ExtendedGuestChatComplete =
/*#__PURE__*/
function (_pb_1$GuestChatComple) {
  _inherits(ExtendedGuestChatComplete, _pb_1$GuestChatComple);

  function ExtendedGuestChatComplete(properties) {
    var _this;

    _classCallCheck(this, ExtendedGuestChatComplete);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExtendedGuestChatComplete).call(this, properties));
    _this.type = ExtendedGuestChatComplete.type;
    _this.chreqid = properties.session.chreqid;
    return _this;
  }

  _createClass(ExtendedGuestChatComplete, [{
    key: "toMQTT",
    value: function toMQTT() {
      var topic = "".concat(this.session.property).concat(ExtendedGuestChatComplete.context);
      var mqttMessage = new paho_mqtt_1.Message(pb_1.GuestChatComplete.encode(this).finish());
      mqttMessage.destinationName = topic;
      mqttMessage.qos = 1;
      return mqttMessage;
    }
  }], [{
    key: "fromMQTT",
    value: function fromMQTT(mqttMessage) {
      return new ExtendedGuestChatComplete(pb_1.GuestChatComplete.decode(mqttMessage.payloadBytes));
    }
  }]);

  return ExtendedGuestChatComplete;
}(pb_1.GuestChatComplete);

ExtendedGuestChatComplete.type = "GuestChatComplete";
ExtendedGuestChatComplete.context = "/guest-chat/complete";
exports.GuestChatComplete = ExtendedGuestChatComplete;